import { Fe87v2DeviceList } from '@/define/device_vendor'
import { KK, VK } from '@/define/define'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { getCurrentDevice } from '@/profiles/selector'
import { BaseDriver } from '@hid/driver/device'
import { deviceManager } from '@hid/device/device_manager'
import { DeviceManager } from './device'

const legacySelfDevFnHiddenBaseKeys: VK[] = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57]

export class FnLayerCapability {
  static getDeviceReadbackMode(): 'layout-overlay' | 'keymap-overlay' | 'none' {
    try {
      const driver = requireDriver()
      if (driver.getFnLayoutOverlay !== BaseDriver.prototype.getFnLayoutOverlay) {
        return 'layout-overlay'
      }
      if (driver.getFnKeyMapOverlay !== BaseDriver.prototype.getFnKeyMapOverlay) {
        return 'keymap-overlay'
      }
    } catch {
      return 'none'
    }

    return 'none'
  }

  static isSupported(): boolean {
    return !specialCheckCurrent(speciaBehiver.NotSupportFnKey)
  }

  static isEditable(): boolean {
    return this.isSupported()
  }

  static isStableOnlyDevice(): boolean {
    return this.isSupported() && !this.isEditable()
  }

  static supportsFactoryReset(): boolean {
    if (!this.isEditable()) {
      return false
    }

    return true
  }

  static getReadonlyFnKeys(): KK[] {
    if (!this.isSupported()) {
      return []
    }

    return [...getCurrentDevice.value.fnDisableKeys]
  }

  static getHiddenBaseSelectionKeys(): VK[] {
    if (this.isEditable()) {
      return []
    }
    if (specialCheckCurrent(speciaBehiver.DevicesOfSelfDevMagnet)) {
      return [...legacySelfDevFnHiddenBaseKeys]
    }
    return []
  }

  static shouldHideBaseSelectionKey(key: VK): boolean {
    return this.getHiddenBaseSelectionKeys().includes(key)
  }

  static getDisplayInoperableKeys(fe87v2ThanOrEqual210: boolean): KK[] {
    let keys = [...getCurrentDevice.value.inoperableKeys]
    if (Fe87v2DeviceList.includes(DeviceManager.instance.state.currentPid) && fe87v2ThanOrEqual210) {
      keys = keys.filter((item) => item !== 0x00)
    }
    return keys
  }
}

const requireDriver = () => deviceManager.deviceDriver
